export const addProductPageId = (parameters) => {
  const productPageId = Number(window.page_context?.item_details?.id);

  if (!productPageId) {
    return parameters;
  }

  return {
    ...parameters,
    product_page_id: productPageId,
  };
};
